export default {
    pickerView: {
        margin: 'auto',
    },
};
